



























import mixins from 'vue-typed-mixins';
import buildTokenMixin from '@/Admin/TicketTemplate/TokenMixin';
import I18nMixin from '@/Shared/I18nMixin';
import { Image } from './Types';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { AxiosResponse } from 'axios';

export default mixins(I18nMixin, LocationBasedMixin, buildTokenMixin<Image>()).extend({
    data() {
        return {
            imageUpload: null as File | null,
            imageBase64: ''
        };
    },
    computed: {
        i18nPrefix() {
            return 'admin.ticketTemplateBuilder.commandToken.commands';
        },
        canUpload(): boolean {
            return !!this.imageUpload && (this.imageUpload as File).size > 0;
        },
        imageRender(): string {
            const base64 =
            !!this.imageBase64 ?
                this.imageBase64 :
                !!this.token && !!(this.token as unknown as Image).bitmapByteArray ?
                (this.token as unknown as Image).bitmapByteArray :
                '';
            return base64 ? `data:image/bmp;base64,${base64}` : '';
        }
    },
    methods: {
        async uploadImage() {
            const formData = new FormData();
            let success = false;

            try {
                formData.append('file', (this.imageUpload as File), (this.imageUpload as File).name);

                const uploadResponse = (
                    await VatsAPI.post<Image>(
                        `${this.location}/ticketTemplate/createImageCommand`,
                        formData
                    ).catch(error => {
                        this.$bvToast.toast(
                            this.i18nLocal('uploadError').toString(),
                            {
                                title: this.i18nCommon('error').toString(),
                                autoHideDelay: 5000
                            }
                        );
                    }));

                // not reactive, but can't reassign because parent depends on reference
                Object.assign(this.token, (uploadResponse as AxiosResponse).data);

                // override whatever was originally passed in for byteArray (if anything)
                this.imageBase64 = (this.token as unknown as Image).bitmapByteArray;
                success = true;
            }
            catch {
                this.$bvToast.toast(
                    this.i18nLocal('uploadError').toString(),
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }

            return success;
        }
    }
});
